import Logo from "../components/Logo";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-4 py-10 sm:py-14">
        <Logo />
        <h1 className="mt-8 text-3xl font-extrabold text-pbs-dark">Privacy Policy</h1>
        <p className="mt-1 text-sm text-pbs-grey">Last updated: October 2026</p>
        <div className="mt-6 space-y-5 text-[15px] leading-relaxed text-pbs-dark/90">
          <p>PlotBySquare is the brand name of Shivora Square India Private Limited ("we", "our"). We collect only the information needed to respond to your enquiry — typically your name, phone number, email, preferred location and budget.</p>
          <h2 className="text-lg font-bold text-pbs-dark pt-2">How we use your information</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>To connect you with a PlotBySquare property expert about your enquiry.</li>
            <li>To share details of properties, projects or offers you asked about.</li>
            <li>To improve our listings and services.</li>
          </ul>
          <h2 className="text-lg font-bold text-pbs-dark pt-2">What we don't do</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>We do not sell your personal information.</li>
            <li>We do not share your details with unrelated third parties.</li>
            <li>We do not send marketing you didn't ask for.</li>
          </ul>
          <h2 className="text-lg font-bold text-pbs-dark pt-2">Your choices</h2>
          <p>You can ask us to update or delete your details at any time by contacting us at <a href="mailto:hello@plotbysquare.com" className="font-semibold text-pbs-purple hover:underline">hello@plotbysquare.com</a>.</p>
          <h2 className="text-lg font-bold text-pbs-dark pt-2">Security</h2>
          <p>Your enquiry data is stored securely and access is limited to authorised PlotBySquare team members.</p>
        </div>
      </div>
    </div>
  );
}
